import pageLanguage from './pageLanguage'
import { useTranslation } from 'react-i18next'

const lng = pageLanguage()

const getParameter = (param) => {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(param)
  return value
}

const AppFilter = () => {
  const brand = getParameter("brand");
  const brandParam = brand!= null
  const { t } = useTranslation()
  let filter = 'parentTitle:Devices'

  if (lng === 'ar') {
    filter = brandParam ? `parentTitle:الأجهزة AND DeviceManufacturer: ${t(brand)}` : 'parentTitle:الأجهزة';
  } else {
    filter = brandParam ? `parentTitle:Devices AND DeviceManufacturer: ${t(brand)}` : 'parentTitle:Devices'
  }

  return filter
}

export { getParameter, AppFilter }